import { tableModule } from '@/store/table/module'

const getTableState = (tableName: string) => {
    return tableModule.state[tableName]
}

export default {
    getTableState,
}
